module.exports = __webpack_public_path__ + "static/media/MaggytheFrog.b7f29764.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/list-tiles/MaggytheFrog.png
// module id = 255
// module chunks = 0